// @mui
import { styled } from '@mui/material/styles';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
  IconButton,
  Typography
} from "@mui/material";
// components
import Image from "../../components/Image";
import Iconify from "../../components/Iconify";
import DIOText from '../../components/DIOText';
import AverageSalaryChart from './AverageSalaryChart';


const ListStyle = styled('ul')(({ theme }) => {
  return {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  }
});

const ListItemStyle = styled('li')(({ theme }) => {
  return {
    color: theme.palette.grey[700],
  }
});

const AVG_DESCRIPTION = {
  "개발자": [
    "DIO가 추천하는 금액이 아닌, 최근 3개월 평균 계약 금액입니다.",
    "표를 참고하되, 상황에 맞게 변경해서 제안해주세요.",
  ],
  "마케터": [
    "DIO가 추천하는 금액이 아닌, 최근 3개월 평균 계약 금액입니다.",
    "표를 참고하되, 상황에 맞게 변경해서 제안해주세요.",
  ],
  "디자이너": [
    "DIO가 추천하는 금액이 아닌, 최근 3개월 평균 계약 금액입니다.",
    "표를 참고하되, 상황에 맞게 변경해서 제안해주세요.",
  ],
  "설계 / 기획 / 관리": [
    "DIO가 추천하는 금액이 아닌, 최근 3개월 평균 계약 금액입니다.",
    "표를 참고하되, 상황에 맞게 변경해서 제안해주세요.",
  ],
}

export default function IsRightSalaryDialog({ isOpen, close, crewNickname, crewPosition, average, detailIndex }) {
  const detail = average?.details?.[detailIndex];

  const getAvgSalaryImageURL = (position) => {
    if (!position) return '';

    if (position === '마케터') {
      return 'https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/avg-salary-marketer.png';
    }
    if (position === '개발자') {
      return 'https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/avg-salary-developer.png';
    }
    if (position === '디자이너') {
      return 'https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/avg-salary-designer.png';
    }
    if (position === '설계 / 기획 / 관리') {
      return 'https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/avg-salary-product-manager.png';
    }
  }

  function DialogTitleWithCloseButton(props) {
    const { children, onClose, ...other } = props;

    return (
      <DialogTitle sx={{ m: 0, mb: 1, pt: { xs: 3, sm: 4 }, px: { xs: 3, sm: 4 } }} {...other}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 16,
              top: { xs: 16, sm: 24 },
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Iconify icon={'eva:close-fill'} />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  }

  return (
    <Dialog open={isOpen} onClose={close} fullWidth maxWidth="md">
      <DialogTitleWithCloseButton id="is-right-dialog-title" onClose={close} variant="subtitle1">
        이 금액이 적당한지 궁금하신가요?
      </DialogTitleWithCloseButton>
      <DialogContent sx={{ px: { xs: 3, sm: 4 }, mb: 1 }}>
        {detailIndex >= 0 && (
          <>
          <Typography variant="body2" color="grey.700" sx={{ pt: {xs: 3, sm: 4 }}}>
            1. {crewNickname} 크루님에게 해당되는 <b>'{crewPosition} {detail?.label}'</b> 평균 계약 금액 테이블입니다.
          </Typography>
          <AverageSalaryChart amount={average} detailIndex={detailIndex} />
          </>
        )}
        <Typography variant="body2" color="grey.700" sx={{ pt: {xs: 3, sm: 4 }}}>
          {detailIndex >= 0 ? '2. ' : ''}<b>{crewPosition} 연차별 <DIOText /></b> 평균 계약 금액 테이블입니다.
        </Typography>
        <Image
          visibleByDefault
          disabledEffect
          src={getAvgSalaryImageURL(crewPosition)}
          alt="averageSalaryTable"
        />
        <ListStyle sx={{ mb: 3 }}>
        {AVG_DESCRIPTION?.[crewPosition]?.map((desc, index) => (
          <ListItemStyle key={index}>
            <Typography variant="caption">
              {desc}
            </Typography>
          </ListItemStyle>
        ))}
        </ListStyle>
        <Button
          sx={{ ml: -1, justifyContent: 'start', color: 'text.secondary' }}
          endIcon={<Iconify icon="ic:chevron-right" />}
          size="medium"
          onClick={() => {window.open('https://dio.oopy.io/faq-price')}}
        >
          자세히 보기
        </Button>
      </DialogContent>
    </Dialog>
  )
}